"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _reactRedux = require("react-redux");

var _reactRouter = require("react-router");

var _has2 = _interopRequireDefault(require("lodash/has"));

var listingActions = _interopRequireWildcard(require("./listingModule"));

var termsActions = _interopRequireWildcard(require("../terms/termsModule"));

var _ListingDetails = _interopRequireDefault(require("./ListingDetails"));

var _userProfileModule = require("../userProfile/userProfileModule");

var _Header = _interopRequireDefault(require("../shared/Header"));

var _LoadingIndicator = _interopRequireDefault(require("../shared/LoadingIndicator"));

var _utils = require("../utils");

var _withAppContext = require("../HOCs/withAppContext");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Listing =
/*#__PURE__*/
function (_Component) {
  _inherits(Listing, _Component);

  function Listing() {
    _classCallCheck(this, Listing);

    return _possibleConstructorReturn(this, _getPrototypeOf(Listing).apply(this, arguments));
  }

  _createClass(Listing, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _has2.default)(this.props, "listing[".concat(this.props.params.id, "].data.core.clientOptInType"))) {
        if (this.props.listing[this.props.params.id].data.core.clientOptInType === 'ADMIN') {
          if (this.props.userPrefs.userId && (0, _has2.default)(this.props, 'profile.Role') && this.props.profile.Role === 1) {
            this.props.fetchLOAStatus(this.props.userPrefs.userId);
          }

          this.props.fetchLOAContent();
        }

        if (this.context.isPublic) {
          if ((0, _utils.canUseDOM)() && window.utag) {
            (0, _utils.sendPublicView)();
          }
        }

        if (this.props.userPrefs && this.props.userPrefs.userId) {
          this.props.fetchTermsStatus(this.props.userPrefs.userId);
        }
      }
    }
  }, {
    key: "getListing",
    value: function getListing() {
      return this.props.listing[this.props.params.id];
    }
  }, {
    key: "getPageTitle",
    value: function getPageTitle() {
      var listing = this.getListing();

      if (!listing || listing.readyState !== listingActions.LISTING_FETCHED) {
        return 'Listing';
      }

      return listing.data.localized.name;
    }
  }, {
    key: "renderListing",
    value: function renderListing() {
      var _this$props = this.props,
          userPrefs = _this$props.userPrefs,
          terms = _this$props.terms,
          offerings = _this$props.offerings;
      var _this$props$listing = this.props.listing,
          localizedRegions = _this$props$listing.localizedRegions,
          localizedCountries = _this$props$listing.localizedCountries;
      var listing = this.getListing().data;
      return _react.default.createElement(_ListingDetails.default, {
        terms: terms,
        listing: listing,
        userPrefs: userPrefs,
        offerings: offerings,
        localizedRegions: localizedRegions,
        localizedCountries: localizedCountries
      });
    }
  }, {
    key: "render",
    value: function render() {
      var readyState = this.getListing() ? this.getListing().readyState : listingActions.LISTING_FETCHING;
      var listingIsLoaded = readyState === listingActions.LISTING_FETCHED || readyState === listingActions.LISTING_NOT_FOUND;
      var listingTitle = readyState === listingActions.LISTING_FETCHED ? this.getListing().data.localized.title : ''; // TODO: figure out why the details page won't update canonical, then re-enable
      // const links = [];
      // const listingID = listingIsLoaded ? this.getListing().data.ID : '';
      // if (isPublic(this.props.location.pathname) && listingIsLoaded) {
      //   links.push({
      //     href: `https://www.concur.com/app-center/listing/${listingID}`,
      //     rel: 'canonical',
      //   });
      // }

      var metaTags = [{
        name: 'description',
        content: listingIsLoaded ? listingTitle : 'App Center Listing'
      }];
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactHelmet.default, {
        meta: metaTags,
        title: this.props.context.getTitle(this.getPageTitle())
      }), _react.default.createElement(_Header.default, {
        listingId: this.props.params.id
      }), _react.default.createElement("div", {
        style: {
          minHeight: '550px'
        }
      }, _react.default.createElement(_LoadingIndicator.default, {
        isLoaded: listingIsLoaded,
        beta: this.props.profile && this.props.profile.betas['concur-ui-spinner']
      }, readyState === listingActions.LISTING_FETCHED && (0, _utils.canUseDOM)() && this.renderListing())));
    }
  }]);

  return Listing;
}(_react.Component);

Listing.propTypes = {
  dispatch: _propTypes.default.func,
  params: _propTypes.default.any,
  listing: _propTypes.default.object,
  isAppCenterEnabledCheck: _propTypes.default.func.isRequired,
  fetchListingIfNeeded: _propTypes.default.func.isRequired,
  fetchTermsStatus: _propTypes.default.func.isRequired,
  fetchLOAStatus: _propTypes.default.func.isRequired,
  fetchLOAContent: _propTypes.default.func.isRequired,
  terms: _propTypes.default.shape({
    appcenterStatus: _propTypes.default.object,
    isTaCModalOpen: _propTypes.default.bool,
    appcenterTerms: _propTypes.default.string,
    ereceiptTerms: _propTypes.default.string,
    ereceiptStatus: _propTypes.default.object,
    sharedInfoStatus: _propTypes.default.object
  }),
  userPrefs: _propTypes.default.object
};

function mapStateToProps(state) {
  return {
    listing: state.listing,
    userPrefs: state.userPrefs,
    terms: state.terms,
    offerings: state.userProfile.offeringsEnabled,
    profile: state.userProfile.profile
  };
}

var mapDispatchToProps = {
  fetchListingIfNeeded: listingActions.fetchListingIfNeeded,
  fetchTermsStatus: termsActions.fetchTermsStatus,
  fetchLOAStatus: termsActions.fetchLOAStatus,
  fetchLOAContent: termsActions.fetchLOAContent,
  isAppCenterEnabledCheck: _userProfileModule.isAppCenterEnabledCheck
};

var _default = (0, _reactRouter.withRouter)((0, _withAppContext.withAppContext)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Listing)));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/listing/ListingContainer.js
// module id = 253
// module chunks = 0